import React from 'react'

import ArrowBack from './svgs/arrow_back.svg'
import Brand from '../images/brand.svg'
import Bullet from './svgs/bullet.svg'
import CardCheckSelected from './svgs/cardCheck-selected.svg'
import CardCheckUnselected from './svgs/cardCheck-unselected.svg'
import CheckSelected from './svgs/check-selected.svg'
import CheckUnselected from './svgs/check-unselected.svg'
import Edit from './svgs/edit.svg'
import ExpandMore from './svgs/expand_more.svg'
import GreenLeaf from './svgs/greenLeaf.svg'
import NavigateNext from './svgs/navigate_next.svg'
import NavigatePrevious from './svgs/navigate_previous.svg'
import Package from './svgs/package.svg'

import {SvgListProps} from '../../props_reusable'

/* SVGS FROM EXTERNAL SOURCE
=================================================== */
import InternalServerError from './svgs/internal_server_error.svg'
import NotFound from './svgs/not_found.svg'
import ErrorCircle from './svgs/error_circle.svg'

export interface AhdIconTypes {
  ap_type:
    | 'arrowBack'
    | 'brand'
    | 'bullet'
    | 'cardCheckSelected'
    | 'cardCheckUnselected'
    | 'checkSelected'
    | 'checkUnselected'
    | 'edit'
    | 'expandMore'
    | 'greenLeaf'
    | 'navigateNext'
    | 'navigatePrevious'
    | 'package'
    | 'internalServerError'
    | 'notFound'
    | 'errorBoundary'
  ap_color?:
    | 'white'
    | 'black'
    | 'action'
    | 'disabled'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning'
    | string
}

const iconsList: SvgListProps = {
  arrowBack: <ArrowBack />,
  brand: <Brand />,
  bullet: <Bullet />,
  cardCheckSelected: <CardCheckSelected />,
  cardCheckUnselected: <CardCheckUnselected />,
  checkSelected: <CheckSelected />,
  checkUnselected: <CheckUnselected />,
  edit: <Edit />,
  expandMore: <ExpandMore />,
  greenLeaf: <GreenLeaf />,
  navigateNext: <NavigateNext />,
  navigatePrevious: <NavigatePrevious />,
  package: <Package />,
  internalServerError: <InternalServerError />,
  notFound: <NotFound />,
  errorBoundary: <ErrorCircle />,
}

export default iconsList
